import React, { useState, useEffect } from "react";
import { siteConfig } from "../mock";
import { Phone } from "lucide-react";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1240px] mx-auto px-6 h-[70px] flex items-center justify-end">
        <a
          href={`tel:${siteConfig.phoneRaw}`}
          aria-label={siteConfig.phone}
          className="inline-flex items-center gap-2 px-5 py-2 rounded-md border border-white/25 text-white text-[15px] tracking-wide hover:bg-white hover:text-black transition-colors duration-200"
        >
          <Phone className="w-4 h-4" />
          <span>{siteConfig.phone}</span>
        </a>
      </div>
    </header>
  );
};

export default Header;
